import React from 'react'
import { Torch } from '@/services/TorchesService'
import { Project } from '@/types/codegen-federation'
import { ICampaignAssets } from '@/types/generated-contentful'
import { useTranslate } from '@/utils/translate/translate-client'
import Section from './Section'
import TorchCard from './TorchCard'

interface TorchCardsProps {
  campaignAssets: ICampaignAssets[]
  projectsExpressingInterest: Project[]
  torchesInvesting?: Torch[]
  torchesExpressingInterest?: Torch[]
}

export const TorchCards: React.FC<TorchCardsProps> = ({
  campaignAssets,
  projectsExpressingInterest,
  torchesInvesting,
  torchesExpressingInterest,
}) => {
  const { t } = useTranslate('torches')
  const projectsSeekingSupport = t('projectsSeekingSupport', 'Projects Seeking Support')
  const bringNewStoriesToLife = t('bringNewStoriesToLife', 'Bring new stories to life')

  if (!torchesInvesting?.length && !torchesExpressingInterest?.length) return null

  const torchesCount = Number(torchesInvesting?.length) + Number(torchesExpressingInterest?.length)
  const torchesLayout = torchesCount > 2 ? 'fixed' : 'responsive'

  return (
    <div className="w-full text-white">
      {!!torchesCount && (
        <Section
          className="mb-20"
          itemsCount={torchesCount}
          layout={torchesLayout}
          title={projectsSeekingSupport}
          subtitle={bringNewStoriesToLife}
        >
          {torchesInvesting?.map((torch) => (
            <TorchCard
              key={torch.id}
              campaignAssets={campaignAssets}
              layout={torchesLayout}
              torch={torch}
              isInvesting
            />
          ))}
          {projectsExpressingInterest.map((project) => (
            <TorchCard
              key={project.id}
              campaignAssets={campaignAssets}
              layout={torchesLayout}
              torch={torchesExpressingInterest?.find(
                (t) => t.campaignSlug === project.activeInterestInitiative?.contentfulSlug,
              )}
              projectExpressingInterest={project}
            />
          ))}
        </Section>
      )}
    </div>
  )
}
